import { Route, Routes } from 'react-router'
import CustomerUserRegister from '../routes/CustomerUserRegister.route'
import CustomerUserRequestPasswordReset from '../routes/CustomerUserRequestPasswordReset.route'
import CustomerUserResetPassword from '../routes/CustomerUserResetPassword.route'
import Login from '../routes/Login.route'
import ForgotPassword from '../routes/ForgotPassword.route'
import ResetPassword from '../routes/ResetPassword.route'
import Register from '../routes/Register.route'
import GetStartedRoute from '../routes/GetStarted.route'
import ErrorRouteContent from '../components/ErrorRouteContent'
import Dashboard from '../routes/Dashboard.route'
import CustomerUsers from '../routes/CustomerUsers.route'
import Media from '../routes/Media.route'
import Users from '../routes/Users.route'
import EditorMobile from '../routes/EditorMobile.route'
import BlogRoute from '../routes/Blog.route'
import CalendarRoute from '../routes/Calendar.route'
import Sponsors from '../routes/Sponsors.route'
import Account from '../routes/Account.route'
import Courses from '../routes/Courses.route'
import CourseEditor from '../routes/CourseEditor.route'
import { ROUTE } from '../cnst/router.cnst'
import EditorRoute from '../routes/Editor.route'
import CmsEditorRoute from '../routes/CmsEditor.route'
import EcommerceRoute from '../routes/Ecommerce.route'

const Router = () => {
  return (
    <Routes>
      <Route path={ROUTE.DASHBOARD} Component={Dashboard} />
      <Route path={ROUTE.LOGIN} Component={Login} />
      <Route path={ROUTE.FORGOT_PASSWORD} Component={ForgotPassword} />
      <Route path={ROUTE.RESET_PASSWORD} Component={ResetPassword} />
      <Route path={ROUTE.REGISTER} Component={Register} />
      <Route path={ROUTE.GET_STARTED} Component={GetStartedRoute} />
      <Route path={ROUTE.CUSTOMER_USER_REGISTER} Component={CustomerUserRegister} />
      <Route path={ROUTE.CUSTOMER_USER_REQUEST_PASSWORD_RESET} Component={CustomerUserRequestPasswordReset} />
      <Route path={ROUTE.CUSTOMER_USER_RESET_PASSWORD} Component={CustomerUserResetPassword} />
      <Route path={ROUTE.USERS} Component={Users} />
      <Route path={ROUTE.CUSTOMER_USERS} Component={CustomerUsers} />
      <Route path={ROUTE.MEDIA} Component={Media} />
      <Route path={ROUTE.EDITOR} Component={EditorRoute} />
      <Route path={ROUTE.EDITOR_MOBILE} Component={EditorMobile} />
      <Route path={ROUTE.CMS_EDITOR} Component={CmsEditorRoute} />
      <Route path={ROUTE.BLOG} Component={BlogRoute} />
      <Route path={ROUTE.CALENDAR} Component={CalendarRoute} />
      <Route path={ROUTE.SPONSORS} Component={Sponsors} />
      <Route path={ROUTE.ACCOUNT} Component={Account} />
      <Route path={ROUTE.COURSES} Component={Courses} />
      <Route path={ROUTE.COURSE} Component={CourseEditor} />
      <Route path={ROUTE.ECOMMERCE} Component={EcommerceRoute} />
      <Route path='*' Component={ErrorRouteContent} />
    </Routes>
  )
}

export default Router
